import React,{useState} from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";



const SingleWork= (props) => {
    const {
      fileUrl,
       name,
       description,
       type,
      
    } = props.product;
    const [reviewModal, setReviewModal] = useState(false);
    return (
       <>
          <div className="col-lg-12 col-xl-6" >
             <div style={{backgroundColor:'#eef5f6'}} className="card">
                <div className="card-body">
                   <h3 style={{ justifyContent:"center", fontFamily: 'serif, élégante et légère', fontSize: '24px', fontWeight: 'bold', marginBottom: '18px' }}>                      
                                 {type}                            
                    </h3>
                   <div className="row m-b-30">
                      <div className="col-md-7 col-xxl-12">
                         <div className="new-arrival-product mb-4 mb-xxl-4 mb-md-0">
                            <div className="new-arrivals-img-contnent cursor-pointer">
                            <img className="img-fluid" src={fileUrl} alt="" crossOrigin="anonymous" />

                            </div>
                           
                         </div>
                      </div>
                      <div className="col-md-5 col-xxl-12">
                         <div className="new-arrival-content position-relative">
                           
                           
                           
                            <h3 style={{color:'#79ca31', fontFamily:"sans-serif, légère et aérée", display: 'flex', justifyContent:"center",  marginBottom: '8px', fontWeight:'bold'}}>
                              
                               {name}
                            </h3>
                           
                            <p style={{ fontFamily: 'sans-serif, fluide et lisible', fontSize: '16px', marginBottom: '8px',display: 'flex', justifyContent:"center" }} className="text-content">{description}</p>
                            
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <Modal show={reviewModal} onHide={setReviewModal} className="modal fade" id="reviewModal" centered>
           <>
             <div className="modal-content">
               <div className="modal-header">
                 <h5 className="modal-title">Review</h5>
                 <button
                   type="button"
                   className="btn-close"                  
                   onClick={() => setReviewModal(false)}
                 >
                   {/* <span>×</span> */}
                 </button>
               </div>
               <div className="modal-body">
                 <form
                   onSubmit={(e) => {
                     e.preventDefault();
                     setReviewModal(false);
                   }}
                 >
                   <div className="text-center mb-4">
                     <img
                       className="img-fluid rounded"
                       width={78}
                       src='{avatar1}'
                       alt="DexignZone"
                     />
                   </div>
                   <div className="form-group">
                     <div className="rating-widget mb-4 text-center">
                       {/* Rating Stars Box */}
                       <div className="rating-stars">
                         <ul
                           id="stars"
                           className="d-flex justify-content-center align-items-center"
                         >
                           <li className="star" title="Poor" data-value={1}>
                             <i className="fa fa-star fa-fw" />
                           </li>
                           <li className="star" title="Fair" data-value={2}>
                             <i className="fa fa-star fa-fw" />
                           </li>
                           <li className="star" title="Good" data-value={3}>
                             <i className="fa fa-star fa-fw" />
                           </li>
                           <li className="star" title="Excellent" data-value={4}>
                             <i className="fa fa-star fa-fw" />
                           </li>
                           <li className="star" title="WOW!!!" data-value={5}>
                             <i className="fa fa-star fa-fw" />
                           </li>
                         </ul>
                       </div>
                     </div>
                   </div>
                   <div className="form-group">
                     <textarea
                       className="form-control"
                       placeholder="Comment"
                       rows={5}
                       defaultValue={""}
                     />
                   </div>
                   <button className="btn btn-primary btn-block">RATE</button>
                 </form>
               </div>
             </div>
           </>
         </Modal>
       </>
    );
 };

export default SingleWork;